import SelectDataAccessModalController from './SelectDataAccessModal.controller';

export default /*@ngInject*/ function ($scope, $uibModal, RequestManagementOracleCloudLoadDataService) {

    activate();

    function activate() {
        $scope.vm = $scope.$parent.vm;
        $scope.loadingDataAccess = false;
        $scope.selectedRole = null;
        $scope.search = { roles: '', assignments: '' };

        if (!$scope.vm.OracleCloudDataAccessAssignments) {
            $scope.vm.OracleCloudDataAccessAssignments = [];
        }

        // Auto-select the first role if available
        if ($scope.vm.ListOfSelectedOracleCloudRoles && $scope.vm.ListOfSelectedOracleCloudRoles.length > 0) {
            $scope.selectedRole = $scope.vm.ListOfSelectedOracleCloudRoles[0];
        }

        // Listen for wizard step changes - load assignments when navigating to this step
        $scope.$on('broadcast-im-wizardstepchange', function (event, args) {
            if (args != null && args.toStep === 'Oracle Cloud Data Access Assignments') {
                loadDataAccessAssignments();
            }
        });
    }

    function loadDataAccessAssignments() {
        if (!$scope.selectedRole && $scope.vm.ListOfSelectedOracleCloudRoles && $scope.vm.ListOfSelectedOracleCloudRoles.length > 0) {
            $scope.selectedRole = $scope.vm.ListOfSelectedOracleCloudRoles[0];
        }

        $scope.loadingDataAccess = true;
        RequestManagementOracleCloudLoadDataService.loadDataAccessAssignments($scope)
            .then(function () {
                $scope.loadingDataAccess = false;
            })
            .catch(function () {
                $scope.loadingDataAccess = false;
            });
    }

    $scope.selectRole = function (role) {
        $scope.selectedRole = role;
        $scope.search.assignments = '';
    };

    $scope.getAssignmentsForRole = function (roleName) {
        return $scope.vm.OracleCloudDataAccessAssignments.filter(function (assignment) {
            return assignment.RoleCode === roleName && assignment.Action !== 'Revoke';
        });
    };

    $scope.addDataAccessAssignment = function (role) {
        var modal = $uibModal.open({
            templateUrl: '/App/Components/RequestManagement/WizardSteps/OracleCloud/SelectDataAccessModal.html',
            controller: SelectDataAccessModalController,
            controllerAs: 'sdamvm',
            backdrop: 'static',
            resolve: {
                selectedRole: function () { return role; },
                existingAssignments: function () { return $scope.vm.OracleCloudDataAccessAssignments; }
            }
        });

        modal.result.then(function (selectedItems) {
            selectedItems.forEach(function (item) {
                var existing = $scope.vm.OracleCloudDataAccessAssignments.find(function (a) {
                    return a.RoleCode === role.RoleName && a.SecurityContext === item.SecurityContext && a.Name === item.Name;
                });
                if (!existing) {
                    $scope.vm.OracleCloudDataAccessAssignments.push({
                        RoleCode: role.RoleName,
                        RoleName: role.DisplayName,
                        RoleDisplayName: role.DisplayName,
                        SecurityContext: item.SecurityContext,
                        Name: item.Name,
                        UserName: $scope.vm.User.OracleCloudUser.UserName,
                        Action: 'Grant'
                    });
                } else if (existing.Action === 'Revoke') {
                    existing.Action = 'Grant';
                }
            });
        }).catch(function () { return; });
    };

    $scope.removeDataAccessAssignment = function (role, assignment) {
        var index = $scope.vm.OracleCloudDataAccessAssignments.indexOf(assignment);
        if (index > -1) {
            if (assignment.Action === 'Grant') {
                $scope.vm.OracleCloudDataAccessAssignments.splice(index, 1);
            } else {
                assignment.Action = 'Revoke';
            }
        }
    };
}
